import { Card, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getProgramsList } from '../../../../../../redux/slices/transitions';
import FormFacilityProgramsField from '../../../FormFields/FormFacilityProgramsField';
import { BUSINESS_DEVELOPMENT } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

FacilityProgramsForm.propTypes = { permissions: PropTypes.object };

export default function FacilityProgramsForm({ permissions }) {
  const dispatch = useDispatch();
  const { watch } = useFormContext();

  const { id: fieldId, fieldName } = BUSINESS_DEVELOPMENT.FACILITY_PROGRAMS;
  const companyId = watch('companyId');

  const {
    data: { programs = {} },
  } = useSelector((state) => state.transitions);
  const dbProgramOptions = programs?.[companyId] ?? [];

  useEffect(() => {
    if (companyId && !programs?.[companyId]) dispatch(getProgramsList(companyId));
  }, [companyId, programs, dispatch]);

  const isEditable = permissions[fieldId];
  if (!(fieldId in permissions)) return null;

  return (
    <Card sx={formCardStyle}>
      <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
        Facility Programs
      </Typography>
      <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
      <FormFacilityProgramsField fieldName={fieldName} dbProgramOptions={dbProgramOptions} isEditable={isEditable} />
    </Card>
  );
}
